var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.154L12.1732 20.5045C10.3042 22.4985 7.2707 22.4985 5.40173 20.5045C3.53276 18.5105 3.53276 15.274 5.40173 13.28L14.1045 3.99215C15.3445 2.66928 17.359 2.66928 18.5989 3.99215C19.8388 5.31503 19.8388 7.46157 18.5989 8.78722L10.0469 17.9114C9.43601 18.5632 8.44304 18.5632 7.83218 17.9114C7.22132 17.2597 7.22132 16.2003 7.83218 15.5486L15.5602 7.3035",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClip);
export default __webpack_public_path__ + "static/media/icon-clip.dbe04af9a752ee2887021cd0af94d298.svg";
export { ForwardRef as ReactComponent };